import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=4577504a&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=4577504a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4577504a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4577504a')) {
      api.createRecord('4577504a', component.options)
    } else {
      api.reload('4577504a', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=4577504a&scoped=true", function () {
      api.rerender('4577504a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/budget/pre_investment/form/detail.vue"
export default component.exports